if (typeof window.__divanoVariantPickerDefined === 'undefined') {
window.__divanoVariantPickerDefined = true;

class DivanoVariantPicker extends HTMLElement {
  connectedCallback() {
    this._onSelect = this._onSelect.bind(this);
    this._onPopState = this._onPopState.bind(this);
    this.addEventListener('divano:variant:select', this._onSelect);
    window.addEventListener('popstate', this._onPopState);
  }

  disconnectedCallback() {
    this.removeEventListener('divano:variant:select', this._onSelect);
    window.removeEventListener('popstate', this._onPopState);
  }

  _onSelect(event) {
    const { paramKey, value } = event.detail || {};
    if (!paramKey || !value) return;

    const url = new URL(window.location.href);
    url.searchParams.set(paramKey, value);
    window.history.replaceState({}, '', url.toString());
  }

  _onPopState() {
    const url = new URL(window.location.href);
    const children = this.querySelectorAll(
      'divano-variant-chip-group, divano-variant-tile-group, divano-variant-tile-grid, divano-variant-slideover'
    );
    children.forEach((child) => {
      const paramKey = child.dataset.paramKey;
      if (paramKey && url.searchParams.has(paramKey)) {
        child.setAttribute('data-selected', url.searchParams.get(paramKey));
      }
    });
  }
}

if (!customElements.get('divano-variant-picker')) {
  customElements.define('divano-variant-picker', DivanoVariantPicker);
}

}
